import React from 'react';
import { promoBanner } from '../mock';
import { ArrowRight, Flame } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

export default function PromoBanner() {
  const { tr } = useI18n();
  return (
    <section className="relative py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl border border-[#e4b44e]/25 bg-gradient-to-br from-[#141110] via-[#0d0c10] to-[#0a090c] shadow-[0_30px_80px_-40px_rgba(228,180,78,0.35)]">
          <div className="absolute inset-0 opacity-40">
            <img src={promoBanner.image} alt="promo" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0a090c] via-[#0a090c]/85 to-transparent" />
          </div>
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#e4b44e]/15 blur-3xl" />

          <div className="relative grid lg:grid-cols-2 gap-10 p-8 md:p-14">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#e4b44e]/12 border border-[#e4b44e]/30 mb-6">
                <Flame className="w-3.5 h-3.5 text-[#f4d896]" />
                <span className="text-[11px] font-extrabold tracking-[0.28em] text-[#f4d896]">{tr('home.badge_sale', promoBanner.tag)}</span>
              </div>
              <h3 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">{tr('home.promo_title', promoBanner.title)}</h3>
              <p className="text-white/70 text-lg leading-relaxed max-w-lg mb-8">{tr('home.promo_desc', promoBanner.description)}</p>
              <div className="flex items-center gap-4 mb-8">
                <div className="px-3 py-1.5 rounded-md bg-white/5 border border-white/10 text-xs font-bold tracking-widest text-white/80">{promoBanner.levelRange}</div>
                <div className="px-3 py-1.5 rounded-md bg-[#e4b44e]/10 border border-[#e4b44e]/30 text-xs font-bold tracking-widest text-[#f4d896]">{promoBanner.edition}</div>
              </div>
              <a href={promoBanner.cta.href} className="btn-gold inline-flex items-center gap-2 h-13 px-8 py-4 rounded-full text-sm font-extrabold tracking-widest group">
                {tr('home.read_more', promoBanner.cta.label)}
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
              </a>
            </div>

            <div className="flex flex-col items-start lg:items-end justify-center">
              <div className="text-right">
                <div className="text-white/40 line-through text-lg mb-1">{promoBanner.oldPrice}</div>
                <div className="font-display text-6xl md:text-7xl font-black gold-text leading-none">{promoBanner.newPrice}</div>
                <div className="mt-3 text-xs tracking-[0.3em] text-[#f4d896]/80">{tr('home.promo_sub', 'SİSTEM DAHİL · %25 İNDİRİM')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
